import { CodeOutlined, DownloadOutlined, ReadOutlined } from "@ant-design/icons";
import { Layout, Menu } from "antd";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";

const StyledLayoutSider = styled(Layout.Sider)`
  overflow: auto;
  min-height: calc(100vh - 64px);
  left: 0;
  top: 64px;
  bottom: 0;
  padding-top: 6px;
  height: 100%;

  .ant-layout-sider-trigger {
    position: absolute;
  }
`;

function AppMenu(props) {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [openKeys, setOpenKeys] = useState(["payments"]);

  const items = [
    {
      key: "",
      icon: <CodeOutlined />,
      title: "API Access",
      label: <Link to="/">API Access</Link>,
    },
    {
      key: "docs",
      icon: <ReadOutlined />,
      title: "Documentation",
      label: (
        <a href="https://developer.getaktos.com/docs/v1" target="_blank" rel="noopener noreferrer">
          Docs
        </a>
      ),
    },
    {
      key: "openapi-spec",
      icon: <DownloadOutlined />,
      title: "Download OpenAPI Spec",
      label: (
        <a
          href="https://developer.getaktos.com/developer-schema/v1"
          target="_blank"
          rel="noopener noreferrer"
        >
          OpenAPI Spec
        </a>
      ),
    },
  ];

  const pathway = location.pathname.substring(1); // removes leading slash
  const selectedKeys = [pathway ?? items[0].key]; // select based on pathway or default to first item
  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  return (
    <StyledLayoutSider
      collapsible
      width={225}
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
    >
      <Menu
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        theme="dark"
        mode="inline"
        items={items}
        selectedKeys={selectedKeys}
      />
    </StyledLayoutSider>
  );
}

export default AppMenu;
